import React, { useState, useEffect } from 'react';
import { ThreeDot } from 'react-loading-indicators';
import HeroSection from '../Components/HeroSection';
import PopularCategories from '../Components/PopularCategories';
import AdsSection from '../Components/AdsSection';
import HowItWorks from '../Components/HowItWorks';
import RecentlyViewedAds from '../Components/RecentlyViewedAds';
import BlogPreview from '../Components/BlogPreview/BlogPreview';

const Home = () => {
  const [latestAds, setLatestAds] = useState([]);
  const [popularAds, setPopularAds] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLatestAds = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/latest-listings`); // Replace with your API endpoint
        const data = await response.json();

        // Transform API data into the format AdCard expects
        const transformedAds = data.listings.map(item => ({
          id: item.id,
          images: item.images,
          category: item.category?.name || 'Brez kategorije',
          title: item.title,
          location: item.seller?.location || null,
          price: item.price,
          created_at: item.created_at,
        }));

        setLatestAds(transformedAds);
      } catch (error) {
        console.error('Failed to fetch latest items:', error);
      }
    };

    const fetchPopularAds = async () => {
      // You can add popular items API fetch here similarly if you have it
      const dummyPopularAds = [];
      setPopularAds(dummyPopularAds);
    };

    fetchLatestAds();
    fetchPopularAds();

    setLoading(false);
  }, []);

  if (loading) {
    return (
      <ThreeDot variant="bounce" color="#FF4367" size="medium" text="Nalaganje" textColor="#FF4367" />
    );
  }

  return (
    <div className="home">
      <HeroSection />
      <AdsSection
        title="Zadnji oglasi"
        items={latestAds}
        buttonLink="/oglasi"
      />
      <RecentlyViewedAds />
      {/*<PopularCategories />
      <AdsSection
        title="Popularni oglasi"
        items={popularAds}
        buttonLink="/popularads"
      />*/}
      <HowItWorks />
      <BlogPreview />
    </div>
  );
};

export default Home;